import { useState } from 'react';
import { Image, Music, Video, FileText, FolderOpen, X } from 'lucide-react';
import FilePickerModal from './FilePickerModal';

interface FileInputProps {
  value: string;
  onChange: (url: string) => void;
  accept?: 'image' | 'audio' | 'video' | 'document';
  placeholder?: string;
  label?: string;
}

function iconForAccept(accept?: string) {
  switch (accept) {
    case 'image': return <Image size={14} className="text-blue-500" />;
    case 'audio': return <Music size={14} className="text-purple-500" />;
    case 'video': return <Video size={14} className="text-red-500" />;
    case 'document': return <FileText size={14} className="text-gray-500" />;
    default: return <FolderOpen size={14} className="text-gray-400" />;
  }
}

export default function FileInput({ value, onChange, accept, placeholder, label }: FileInputProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="input-field pr-8"
            placeholder={placeholder || 'Select or paste URL...'}
            readOnly={false}
          />
          {value && (
            <button
              type="button"
              onClick={() => onChange('')}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <X size={14} />
            </button>
          )}
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="btn-secondary flex items-center gap-1.5 shrink-0 !py-2"
          title="Browse files"
        >
          {iconForAccept(accept)}
          Browse
        </button>
      </div>
      {value && accept === 'image' && (
        <img src={value} alt="preview" className="mt-2 h-16 rounded border border-gray-200 object-cover" />
      )}
      <FilePickerModal
        open={open}
        onClose={() => setOpen(false)}
        onSelect={(file) => onChange(file.url)}
        accept={accept}
      />
    </>
  );
}
